<template>
    <form @submit.prevent="submit">
        <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6 sm:col-span-2">
                    <label for="role" class="block text-sm font-medium text-gray-700">Role</label>
                    <select-input
                        v-if="$page.props.auth.user.role === $SUPER_ADMIN_ROLE || $page.props.auth.user.role === $ADMIN_ROLE"
                        v-model="user.role" id="role" name="role" autocomplete="role" class="mt-1 ">
                        <option v-for="role in roles" :key="role.id" :value="role.id" :disabled="checkPermissions(role)">{{ role.name }}</option>
                    </select-input>
                    <div class="flex items-center block w-full font-mono mt-1 px-4 tracking-wider py-3 border border-gray-300 bg-gray-100 rounded-md" v-else>
                    <svg :class="{
                        'text-red-400' : user.role === $SUPER_ADMIN_ROLE,
                        'text-yellow-400' : user.role === $ADMIN_ROLE,
                        'text-indigo-400' : user.role === $GIN_ROLE,
                        'text-green-400' : user.role === $CUSTOMER_ROLE
                        }" class="-ml-0.5 mr-1.5 h-2 w-2" fill="currentColor" viewBox="0 0 8 8">
                        <circle cx="4" cy="4" r="3" />
                    </svg>
                    {{ $page.props.roles[user.role-1].name }}
                    </div>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <label for="name" class="block text-sm font-medium text-gray-700">Member Name</label>
                    <text-input v-model="user.name" type="text" name="name" id="name" autocomplete="name" class="mt-1" />
                </div>

                <div class="col-span-6 sm:col-span-2">
                    <label for="username" class="block text-sm font-medium text-gray-700">
                        <span v-if="user.role === $CUSTOMER_ROLE">Account Number</span>
                        <span v-else>Username</span>
                    </label>
                    <input class="border-0 mt-1 bg-gray-50 appearance-none block w-full font-mono px-4 tracking-wider py-3 rounded-md" v-model="user.username" type="text" name="username" id="username" autocomplete="username" :disabled="$page.props.auth.user.role !== $SUPER_ADMIN_ROLE" />
                </div>


                <div class="col-span-6 sm:col-span-2">
                    <label for="password" class="block text-sm font-medium text-gray-700 flex sm:justify-between">
                        Password
                        <span v-if="! changePassword && user.id" class="text-xs text-blue-500 cursor-pointer" @click="changePassword = true">Change</span>
                        <span v-if="changePassword" class="text-xs text-blue-500 cursor-pointer" @click="changePassword = false, user.newPassword = null">Cancel</span>
                    </label>
                    <text-input v-if="! changePassword" v-model="user.password" type="password" name="password" id="password" class="mt-1" :disabled="$page.props.auth.user.role !== $SUPER_ADMIN_ROLE" />
                    <text-input v-if="changePassword" v-model="user.newPassword" type="text" required name="newPassword" id="newPassword" class="mt-1" :disabled="$page.props.auth.user.role !== $SUPER_ADMIN_ROLE" />
                </div>

                <div class="col-span-6 sm:col-span-2">
                    <label for="email_address" class="block text-sm font-medium text-gray-700">Email address</label>
                    <text-input v-model="user.email" type="email" name="email_address" id="email_address" autocomplete="email" class="mt-1" :disabled="$page.props.auth.user.role !== $SUPER_ADMIN_ROLE" />
                </div>

                <div class="col-span-6 sm:col-span-2">
                    <label for="phone" class="block text-sm font-medium text-gray-700">Phone Number</label>
                    <text-input v-model="user.phone" type="text" name="phone" id="phone" class="mt-1" :disabled="$page.props.auth.user.role !== $SUPER_ADMIN_ROLE" />
                </div>

                <div v-show="user.role === 3" class="col-span-6 sm:col-span-2">
                    <label for="gin_number" class="block text-sm font-medium text-gray-700">Gin Number</label>
                    <input v-model="user.gin_number" type="text" name="gin_number" id="gin_number" class="mt-1 border-0 mt-1 bg-gray-50 appearance-none block w-full font-mono px-4 tracking-wider py-3 rounded-md" :disabled="$page.props.auth.user.role !== $SUPER_ADMIN_ROLE" />
                </div>

                <div v-show="user.role === 3" class="col-span-6 sm:col-span-2">
                    <label for="lawson_number" class="block text-sm font-medium text-gray-700">Lawson Account Number</label>
                    <input v-model="user.lawson_number" type="text" name="lawson_number" id="lawson_number" :disabled="$page.props.auth.user.role !== $SUPER_ADMIN_ROLE" class="mt-1 border-0 mt-1 bg-gray-50 appearance-none block w-full font-mono px-4 tracking-wider py-3 rounded-md" />
                </div>

                <div v-show="user.role === 3" class="col-span-6 sm:col-span-2">
                    <label for="gin_zone" class="block text-sm font-medium text-gray-700">Gin Zone</label>
                    <input class="border-0 mt-1 bg-gray-50 appearance-none block w-full font-mono px-4 tracking-wider py-3 rounded-md" v-model="user.gin_zone" type="text" name="gin_zone" id="gin_zone"  />
                </div>

            </div>
        </div>
        <div class="px-4 py-3 text-right sm:px-6">
            <loading-button :loading="saving"  type="submit" class="">
                Save
            </loading-button>
        </div>
    </form>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: {
        LoadingButton,
        TextInput,
        SelectInput
    },
    props: {
        user: Object,
        roles: Array
    },
    data() {
        return {
            saving: false,
            changePassword: false
        }
    },
    methods: {
        submit() {
            if (this.user.id) {
                this.$inertia.put(this.route('users.update', this.user.id), this.user, {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => this.changePassword = false,
                })
            } else {
                this.$inertia.post(this.route('users.store'), this.user, {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => this.changePassword = false,
                })
            }
        },
        checkPermissions(role) {
            if (this.user.role === this.$SUPER_ADMIN_ROLE) {
                return true
            }
            if (this.user.role === this.$ADMIN_ROLE && (
                this.role === this.$ADMIN_ROLE ||
                this.role === this.$SUPER_ADMIN_ROLE)) {
                return false
            }
            return false
        }
    }
}
</script>
